"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSelector = void 0;
var toSelector = function (rule) { return ".".concat(rule.split(" ").join(".")); };
exports.toSelector = toSelector;
